import api from './api';

export const fetchPeople = async () => {
  const response = await api.get('/admin/people');
  return Array.isArray(response.data) ? response.data : [];
};

const toFormData = (data, includeMethod = false) => {
  const form = new FormData();
  if (includeMethod) form.append('_method', 'PUT');
  form.append('name', data.name || '');
  form.append('title', data.title || '');
  form.append('description', data.description || '');
  form.append('display_order', String(data.display_order ?? 0));
  if (data.image instanceof File) form.append('image', data.image);
  return form;
};

export const createPerson = async (data) => {
  const response = await api.post('/admin/people', toFormData(data));
  return response.data;
};

export const updatePerson = async (id, data) => {
  const response = await api.post(`/admin/people/${id}`, toFormData(data, true));
  return response.data;
};

export const deletePerson = async (id) => {
  const response = await api.delete(`/admin/people/${id}`);
  return response.data;
};
